import { es, en } from '@formkit/i18n'
import { createProPlugin, inputs } from '@formkit/pro'
import '@formkit/pro/genesis'
import { createAutoHeightTextareaPlugin } from '@formkit/addons'
import { defaultConfig } from '@formkit/vue'
import '@formkit/themes/genesis'

const pro = createProPlugin('fk-67a280dfd', inputs)
export default defaultConfig({
  plugins: [pro, createAutoHeightTextareaPlugin()],
  locales: { es, en },
  locale: 'es',
  theme: 'genesis'
})
